import {
  Req_GetChargeSituationList
} from '@/request/contract'

export default {
  state: {
    activeContract: {},
    handoverMethod:[],
    serviceName:[],
    PaymentMethodList:[],
    chargeSituationList:[],
  },
  mutations: {
    updateHandoverMethod(state,payload){
      state.handoverMethod = payload
    },
    updateServiceName(state,payload){
      state.serviceName = payload
    },
    updateSituationList(state,payload){
      state.chargeSituationList = payload
    },
    updateMethodList(state,payload){
      state.PaymentMethodList = payload
    },
  },
  actions: {
    /**
     * 获取凭证交接列表
     */
    getHandoverMethodList(store){
      const handoverMethod = [
        {
          name:'上门取',
          id:10
        },{
          name:'快递',
          id:20
        },{
          name:'企业自送',
          id:30
        }
      ]
      store.commit('updateHandoverMethod',handoverMethod)
    },
    /**
     * 获取服务名称列表
     */
    getServiceNameList(store){
      const serviceName = [
        {
          name:'记账报税(0元/月)',
          id:0
        },{
          name:'汇算清缴(0元/年)',
          id:1,
        },{
          name:'账本费(0元/年)',
          id:2
        }
      ]
      store.commit('updateServiceName',serviceName)
    },
    /**
     * 获取收款方式
     */
    getPaymentMethodList(store){
      const methodList = [
        {
          name:'现金',
          id:0,
        },{
          name:'银行转账',
          id:1
        },{
          name:'支付宝',
          id:2
        },{
          name:'微信支付',
          id:3
        },{
          name:'其他',
          id:4
        }
      ]
      store.commit('updateMethodList',methodList)
    },
    /**
     * 获取收费情况列表
     */
    getChargeSituationList(store){
      Req_GetChargeSituationList().then(res => {
        store.commit('updateSituationList',res)
      }).catch(err => this.$catchErr(err))
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/contract.js